export function validateEmail(email) {
	const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return re.test(String(email).toLowerCase());
}

export function validatePassword(password) {
	if (typeof password !== 'string') return false;
	// Minimum 8 characters with at least one letter and one number
	const re = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+\-={}[\]|;:'",.<>/?~]{8,}$/;
	return re.test(password);
}

export function validatePhone(phone) {
	const re = /^[0-9+()\s-]{7,20}$/;
	return re.test(String(phone));
}

export function validateRequired(value, fieldName = 'This field') {
	if (value === null || value === undefined) return `${fieldName} is required`;
	if (typeof value === 'string' && value.trim().length === 0) return `${fieldName} is required`;
	return '';
}


